import { apiSlice } from 'store/api/apiSlice';

export const homePageAPISlice: any = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGroupPromotionByBranchId: builder.query({
      query: ({ branchId }) => ({
        url: `/groupedPromotion/public/all/non-paginated/optimized?branchId=${branchId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    getSearchResultsByBranchId: builder.query({
      query: ({
        branchId,
        searchText,
        sectionId,
      }: {
        branchId: number;
        searchText: string;
        sectionId?: string;
      }) => {
        const params = new URLSearchParams({
          branchId: String(branchId),
          searchText,
        });
        console.log(sectionId, 'sectionId');

        if (sectionId) params.append('sectionId', sectionId);
        return {
          url: `/menuItemMaster/public/menuItemMaster/fuzzySearch?${params.toString()}`,
          method: 'GET',
        };
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetSearchResultsByBranchIdQuery, useGetGroupPromotionByBranchIdQuery } =
  homePageAPISlice;
